import { createFileRoute } from '@tanstack/react-router'
import { z } from 'zod'
import Chats from '@/features/chats'

const chatsSearchSchema = z.object({
  /** Pre-selected Matrix room id (e.g. !abc:server). Set by the
   *  /chadmin Rooms tab 'Chat here' button so an admin jumps straight
   *  into the room they were inspecting. */
  room: z.string().optional(),
  /** Event id to scroll to + highlight (search hits, mention notifications). */
  event: z.string().optional(),
  /** Pre-filled composer text. Set by the Shared Lists originator avatar
   *  (#386 / dev-nest #7c) so clicking it opens chat with an @-mention of the
   *  list's owner + list context already typed into the composer. */
  prefill: z.string().optional(),
})

export const Route = createFileRoute('/_authenticated/chats/')({
  component: Chats,
  validateSearch: chatsSearchSchema,
})
